import { DateTime } from 'luxon';
import { displayMessage } from '../../../services/helper';


export default [
    {
        field: 'image_url',
        headerName: displayMessage('PHOTO'),
        width: 120,
        headerAlign: "center",
        sortable: false,
        align: 'center',
        renderCell: (params) => {
            return (
                <div style={{ width: 80, height: 54, display: "flex", alignItems: 'center', justifyContent: 'center' }}>
                    <img src={params?.row?.Patient?.image_url ? params.row.Patient.image_url : ''} />
                </div>
            )
        }
    },
    {
        field: 'fullName',
        headerName: displayMessage('PATIENT'),
        width: 150,
        headerAlign: "center",
        align: 'center',
        valueGetter: function (params) {
            return `${params?.row?.Patient?.full_name || ''}`
        }
    },
    {
        field: 'dentistFullName',
        headerName: displayMessage('DENTIST'),
        width: 150,
        headerAlign: "center",
        align: 'center',
        valueGetter: function (params) {
            return `${params?.row?.Dentist?.first_name || ''} ${params?.row?.Dentist?.last_name || ''}`
        }
    },
    {
        field: "stars",
        headerName: displayMessage('MONITORY'),
        width: 100,
        headerAlign: "center",
        align: 'right',
        type: 'number',
        renderCell: params => {
            return (
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div>
                        {params.value ? `${params.value} ⭐` : displayMessage('NOT_INFORMED2')}
                    </div>
                </div>
            )
        }
    },
    {
        field: "exercise_stars",
        headerName: displayMessage('EXERCISES'),
        width: 100,
        headerAlign: "center",
        align: 'right',
        type: 'number',
        renderCell: params => {
            return (
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div>
                        {params.value ? `${params.value} ⭐` : displayMessage('NOT_INFORMED2')}
                    </div>
                </div>
            )
        }
    },
    {
        field: 'duration_formatted',
        type: 'number',
        headerName: displayMessage('DURATION'),
        width: 120,
        headerAlign: "center",
        align: 'center',
        valueFormatter: (params) => {
            return `${params?.value}m`
        }
    },
    {
        field: "day_missed",
        headerName: displayMessage('ABSENT_DAY'),
        width: 120,
        headerAlign: "center",
        align: 'center',
        valueFormatter: (params) =>{
            return params?.value >= 1 ? `${displayMessage('MISSING_DAY_TOOLTIP')} ❌` : `${displayMessage('PRESENT')} ✅`
        }
    },
    {
        field: 'control_day',
        type: 'date',
        headerName: displayMessage('CONTROL_DATE'),
        width: 180,
        headerAlign: "center",
        align: 'center',
        valueFormatter: (params) => {
            if (!params?.value) {
                return params?.value
            }
            const data = DateTime.fromISO(params.value).toUTC(); //.startOf('day').toUTC();
            return data.toFormat('dd/MM/yyyy')
        }
    },
    {
        field: "open_lip",
        headerName: displayMessage('OPEN_LIP'),
        width: 120,
        headerAlign: "center",
        align: 'center',
        type: 'number'
    },
    {
        field: "camera_off",
        headerName: displayMessage('CAMERA'),
        width: 160,
        headerAlign: "center",
        align: 'center',
        type: 'number'
    },
    {
        field: "exercise_done",
        headerName: displayMessage('EXERCISE_DONE'),
        width: 120,
        headerAlign: "center",
        align: 'center',
        type: 'boolean'
    },
    {
        field: "camera_position",
        headerName: displayMessage('CAMERA'),
        width: 120,
        headerAlign: "center",
        align: 'center',
        type: 'number'
    },
    {
        field: "correct_execution",
        headerName: displayMessage('EXECUTION'),
        width: 120,
        headerAlign: "center",
        align: 'center',
        type: 'number'
    },
    {
        field: "concentration_activity",
        headerName: displayMessage('ATENTION'),
        width: 120,
        headerAlign: "center",
        align: 'center',
        type: 'number'
    },


]